import React from "react";
import { ReactComponent as Cube } from "../../../assets/squares-bg 4.svg";
import classes from "./MainPageNotifications.module.css";
import { Image } from "antd";
import Cocacola from "../../../assets/cocacola.png";
import Giveaway from "../../../assets/giveaway.png";
import { Link } from "react-router-dom";

const MainPageNotifications = () => {
	const notifications = [
		{
			id: 1,
			title: "Coca Cola zgjedh Postman",
			description:
				"Postman do të bëjë dorëzimin e shpërblimeve për Coca-Cola.",
			image: Cocacola,
		},
		{
			id: 2,
			title: "Postman organizon lojën shpërblyese",
			description: "Loje shperblyese nga POSTMAN- poste e shpejte.",
			image: Giveaway,
		},
	];

	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<div className={classes.titles}>
					<div>
						<h1 className={classes.title}>Njoftimet</h1>
						<p>
							Njoftimet dhe lajmërimet e fundit nga kompania jonë.
						</p>
					</div>
				</div>
				<Cube />
			</div>
			<div className={classes.secondContainer}>
				{/* <Link to={`/notification/${notificationId}`}>
					<div className="flex flex-col gap-3">
						<Image src={Cocacola} preview={false} />
						<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
							Coca Cola zgjedh Postman
						</p>
						<p>
							Postman do të bëjë dorëzimin e shpërblimeve për
							Coca-Cola.
						</p>
					</div>
				</Link>
				<div className="flex flex-col gap-3">
					<Image src={Giveaway} preview={false} />
					<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
						Postman organizon lojën shpërblyese
					</p>
					<p>Loje shperblyese nga POSTMAN- poste e shpejte.</p>
				</div> */}

				{notifications.map((notification) => (
					<Link
						key={notification.id}
						to={`/${notification.title
							.replace(/\s+/g, "-")
							.toLowerCase()}`}
						state={{
							id: notification.id,
							title: notification.title,
						}}
					>
						<div className="flex flex-col gap-3">
							<Image src={notification.image} preview={false} />
							<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
								{notification.title}
							</p>
							<p>{notification.description}</p>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default MainPageNotifications;
